/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SkillInsightPoint = {
  activatedSessions: number;
  activations: number;
  averageScore?: number | undefined;
  bucketStart: Date;
  estimatedMinutesSaved: number;
  scoredSessions: number;
  sessionCostUsd: number;
};

/** @internal */
export const SkillInsightPoint$inboundSchema: z.ZodMiniType<
  SkillInsightPoint,
  unknown
> = z.pipe(
  z.object({
    activated_sessions: z.int(),
    activations: z.int(),
    average_score: z.optional(z.number()),
    bucket_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    estimated_minutes_saved: z.number(),
    scored_sessions: z.int(),
    session_cost_usd: z.number(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activated_sessions": "activatedSessions",
      "average_score": "averageScore",
      "bucket_start": "bucketStart",
      "estimated_minutes_saved": "estimatedMinutesSaved",
      "scored_sessions": "scoredSessions",
      "session_cost_usd": "sessionCostUsd",
    });
  }),
);

export function skillInsightPointFromJSON(
  jsonString: string,
): SafeParseResult<SkillInsightPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillInsightPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillInsightPoint' from JSON`,
  );
}
